import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import translations from './OutputData.translations.json';
import { NotFound } from '../NotFound';
import { OutputDataDirectory } from './OutputDataDirectory';
import { OutputDataProcessingErrorReport } from './errorReport/OutputDataProcessingErrorReport';
import { OutputDataProcessingEventsDirectory } from './processingEvents/OutputDataProcessingEventsDirectory';
import { OutputDataTestCalculationReport } from './testCalculation/OutputDataTestCalculationReport';
import { OutputDataTestValidationReport } from './testValidation/OutputDataTestValidationReport';

export const { addTranslations, Translation } =
  i18nNsFactory('output-data-page');
addTranslations(translations);

export const OUTPUT_DATA_ROUTES = [
  {
    path: path.outputDataDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.output-data')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <OutputDataDirectory />,
      },
      {
        path: path.outputDataErrorDirectory,
        element: <OutputDataProcessingEventsDirectory />,
      },
      {
        path: path.outputDataErrorReport,
        element: <OutputDataProcessingErrorReport />,
      },
      {
        path: path.outputDataTestCalculationReport,
        element: <OutputDataTestCalculationReport />,
      },
      {
        path: path.outputDataTestValidationReport,
        element: <OutputDataTestValidationReport />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const OutputData: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, OUTPUT_DATA_ROUTES));
